// Watchlist storage + push alert helpers (localStorage)

const WATCH_KEY = "ns_watchlist";
const PUSH_KEY = "ns_push_enabled";
const SEEN_FILINGS_KEY = "ns_seen_filings";

export function getWatchlist() {
  try { return JSON.parse(localStorage.getItem(WATCH_KEY) || "[]"); } catch { return []; }
}
export function setWatchlist(list) {
  localStorage.setItem(WATCH_KEY, JSON.stringify(list));
  window.dispatchEvent(new Event("ns_watchlist_changed"));
}
export function addToWatchlist(item) {
  const list = getWatchlist();
  if (list.find(x => x.symbol === item.symbol)) return false;
  list.push({ ...item, added_at: Date.now() });
  setWatchlist(list);
  return true;
}
export function removeFromWatchlist(symbol) {
  setWatchlist(getWatchlist().filter(x => x.symbol !== symbol));
}

export function isPushEnabled() { return localStorage.getItem(PUSH_KEY) === "1"; }
export function setPushEnabled(v) { localStorage.setItem(PUSH_KEY, v ? "1" : "0"); }
export async function requestPushPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") { setPushEnabled(true); return "granted"; }
  if (Notification.permission === "denied") return "denied";
  const r = await Notification.requestPermission();
  if (r === "granted") setPushEnabled(true);
  return r;
}

export function getSeenFilings() {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_FILINGS_KEY) || "[]")); } catch { return new Set(); }
}
export function markFilingsSeen(ids) {
  const seen = getSeenFilings();
  ids.forEach(id => seen.add(id));
  const arr = Array.from(seen).slice(-500); // cap at 500 ids
  localStorage.setItem(SEEN_FILINGS_KEY, JSON.stringify(arr));
}

// Parse ₹ amount (e.g. "₹3,400 Cr") into crores number
export function parseCr(orderValue) {
  if (!orderValue) return 0;
  const s = String(orderValue).replace(/,/g, "");
  const m = s.match(/(\d+(?:\.\d+)?)\s*(cr|bn|billion|mn|million|lakh|l)?/i);
  if (!m) return 0;
  const num = parseFloat(m[1]);
  const unit = (m[2] || "").toLowerCase();
  if (unit.startsWith("cr")) return num;
  if (unit.startsWith("bn") || unit.startsWith("billion")) return num * 100; // 1bn USD ~ approximate; use 100Cr
  if (unit.startsWith("mn") || unit.startsWith("million")) return num / 10;
  if (unit.startsWith("l")) return num / 100;
  return num;
}

export function firePushNotification(title, body, link) {
  if (!isPushEnabled() || !("Notification" in window) || Notification.permission !== "granted") return;
  try {
    const n = new Notification(title, {
      body,
      icon: "https://customer-assets-agu9un31.emergentagent.net/job_invest-pro-170/artifacts/o8ovqyx1_Favicon.png",
      badge: "https://customer-assets-agu9un31.emergentagent.net/job_invest-pro-170/artifacts/o8ovqyx1_Favicon.png",
      tag: "ns-filing",
    });
    if (link) n.onclick = () => { window.focus(); window.open(link, "_blank"); };
  } catch {}
}
